import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { primary_light } from '../../shared/lib/colors';
import { jsx, css } from '@emotion/core';

import CheckoutProgress from './CheckoutProgress/CheckoutProgress';

import './Checkout.scss';
import { Helmet } from 'react-helmet';
import { cleanImage } from '../../../utils/images';

class Checkout extends Component {
  state = {
    helmetTitle: '',
  };

  componentDidMount() {
    this.setHelmetTitle(this.props.location.pathname);
  }

  componentWillReceiveProps(nextProps) {
    this.setHelmetTitle(nextProps.location.pathname);
  }

  getHelmetTitle = pathname => {
    switch (pathname) {
      case '/accedi':
        return 'Login';
      case '/ricetta':
        return 'Ricetta';
      case '/spedizione':
        return 'Spedizione';
      case '/pagamento':
        return 'Pagamento';
      case '/checkout-success':
        return 'Checkout Success';
      case '/checkout-failure':
        return 'Checkout Failure';
      default:
        return '';
    }
  };

  setHelmetTitle = pathname => {
    this.setState({ helmetTitle: this.getHelmetTitle(pathname) });
  };

  render() {
    const isCheckoutSuccess = this.props.router.isActive('checkout-success');
    const { primaryColor, siteName, logoImage } = this.props;

    const checkoutStyle = css`
      .checkout-title {
        background-color: ${primary_light(primaryColor)};
      }
    `;

    return (
      <div className="checkout" css={checkoutStyle}>
        <Helmet
          title={`${this.state.helmetTitle}`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia - ${this.state.helmetTitle}`,
            },
            {
              name: 'keywords',
              content: `${siteName}, Ecommerce Farmacia - ${this.state.helmetTitle}`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:title',
              content: `${this.state.helmetTitle} | ${siteName} - Ecommerce Farmacia`,
            },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia - ${this.state.helmetTitle}`,
            },
            { property: 'og:image', content: cleanImage(logoImage) },
          ]}
        />

        <div className="container">
          {!isCheckoutSuccess && (
            <CheckoutProgress
              primaryColor={primaryColor}
              cart={this.props.cart}
            />
          )}

          {this.props.children}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    primaryColor: state.store.data.loghiTemplate.brandColor,
    cart: state.cart,
    siteName: state.store.data.datiFarmacia.siteName,
    logoImage: state.store.data.loghiTemplate.logoImage,
  };
};

export default withRouter(connect(mapStateToProps)(Checkout));
